/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { forwardRef, memo, useImperativeHandle, useRef } from 'react';
import { Typography } from "../../";
import { getGlobal } from "../../../global";
import { useTheme } from "../../../theme";
import { classNames } from "../../../utils";
const {
  colors: {
    system: {
      disabled: systemDisabled
    },
    semantic: {
      success: semanticSuccess,
      warning: semanticWarning,
      danger: semanticDanger,
      info: semanticInfo
    }
  },
  spacing
} = useTheme();
const colorMap = new Map([['default', semanticDanger], ['success', semanticSuccess], ['warning', semanticWarning], ['danger', semanticDanger], ['info', semanticInfo]]);
const HelperText = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  disabled,
  status,
  className,
  style,
  children,
  id,
  ...props
}, reference) => {
  const ref = useRef(null);
  const color = colorMap.get(status);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return jsx(Typography, {
    ref: ref,
    css: HelperTextRootCSS,
    id: id,
    color: disabled ? systemDisabled : color,
    style: style,
    className: classNames('DGN-UI-HelperText', className),
    type: 'p3',
    fullWidth: false,
    lineClamp: 1,
    ...props
  }, typeof children === 'boolean' ? getGlobal('thisFieldIsRequired') : children);
}));
const HelperTextRootCSS = css`
    margin-top: ${spacing([0.5])}px;
`;
HelperText.defaultProps = {
  disabled: false,
  status: 'default',
  className: '',
  style: {},
  children: ''
};
HelperText.propTypes = {
  /** If true, the component is disabled. */
  disabled: PropTypes.bool,
  /** status type to display color for input (only available for type is inform) */
  status: PropTypes.oneOf(['default', 'warning', 'success', 'danger', 'info']),
  /** Class for component. */
  className: PropTypes.string,
  /** Style inline of component. */
  style: PropTypes.object,
  /** Content to display in component. */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** [Props](https://core.diginet.com.vn/ui/?path=/docs/typography) of Typography */
  props: PropTypes.any
};
export default HelperText;